

document.addEventListener('DOMContentLoaded', () => {
    const slides = document.querySelectorAll('.carousel-item');
    let currentIndex = 0;
    const intervalTime = 6000; // 6 seconds in milliseconds

    const showSlide = (index) => {
        slides.forEach((slide, i) => {
            slide.classList.toggle('hidden', i !== index);
            slide.classList.toggle('active', i === index);
        });
    };

    const nextSlide = () => {
        currentIndex = (currentIndex + 1) % slides.length;
        showSlide(currentIndex);
    };

    // Set up automatic sliding
    const autoSlide = setInterval(nextSlide, intervalTime);

    // Optional: Stop auto-slide on manual button click
    document.getElementById('prevBtn').addEventListener('click', () => {
        clearInterval(autoSlide);
        currentIndex = (currentIndex - 1 + slides.length) % slides.length;
        showSlide(currentIndex);
    });

    document.getElementById('nextBtn').addEventListener('click', () => {
        clearInterval(autoSlide);
        nextSlide();
    });

    showSlide(currentIndex);
});

// Navbar Button
document.addEventListener('DOMContentLoaded', () => {
const navbarToggle = document.getElementById('navbarToggle');
const navbarNav = document.getElementById('navbarNav');

navbarToggle.addEventListener('click', () => {
navbarNav.classList.toggle('hidden');
    });
});



